import { TicketPercent } from 'lucide-react';

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
  DialogClose,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { useCancellationPlan } from 'src/context/billing';

type Props = {
  refetch: () => void;
};

const DiscountRequestDialog = ({ refetch }: Props) => {
  const {
    ui: { step, setInitialData },
  } = useCancellationPlan();

  const onOpenChange = (open: boolean) => {
    if (!open) {
      refetch();
      setInitialData();
    }
  };

  return (
    <Dialog open={step === 'discount-request'} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[512px] gap-6">
        <div className="flex items-center justify-center size-12 shadow-sm rounded-md bg-card border  mx-auto">
          <TicketPercent className="size-6 text-foreground" />
        </div>
        <DialogHeader className="text-center gap-1.5">
          <DialogTitle>Stay and save – Keep your plan for less</DialogTitle>
          <DialogDescription>
            Thank you for choosing to continue your relationship with us! Your discount request will be reviewed, and
            we’ll be in touch with your exclusive offer!
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="sm:justify-center">
          <DialogClose asChild>
            <Button>Back to Billing</Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DiscountRequestDialog;
